import { NotificationSection } from './notification-section';
import { useTranslation } from 'react-i18next';
import type { NotificationToggle } from './notification-toggle.types';
import { ResponsiveSectionTitle } from './responsive-section-title';
import { ToggleRows } from './toggle-rows';

export const ChatNotificationSection = ({
  isLargeUI,
  toggles,
}: {
  isLargeUI: boolean;
  toggles: NotificationToggle[];
}) => {
  const { t } = useTranslation('notifications-setting');
  return (
    <NotificationSection
      title={<ResponsiveSectionTitle {...{ isLargeUI }}>{t('chatTitle')}</ResponsiveSectionTitle>}
      description={t('chatHelp')}
    >
      <ToggleRows {...{ toggles }} />
    </NotificationSection>
  );
};
